module.exports = __webpack_public_path__ + "static/media/sad.57a7e62f.svg";